import script from "./BowlList.vue?vue&type=script&setup=true&lang=js"
export * from "./BowlList.vue?vue&type=script&setup=true&lang=js"

import "./BowlList.vue?vue&type=style&index=0&id=0119180a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0119180a"]])

export default __exports__